import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "highlights-content__unit" }
const _hoisted_2 = { class: "highlights-content__blockquote-box" }
const _hoisted_3 = { class: "highlights-content__icons-box" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont iflag2 highlights-content__bookmark-icon" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "highlights-content__icons-right" }
const _hoisted_9 = { class: "highlights-content__blockquote" }
const _hoisted_10 = { class: "highlights-content__link-date" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "highlights-content__link-icon iconfont ishare-1" }, null, -1)
const _hoisted_12 = { class: "highlights-content__date" }
const _hoisted_13 = { class: "highlights-content__date-num" }
const _hoisted_14 = {
  key: 0,
  class: "highlights-content__notes"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "highlights-content__title" }, "Your Notes", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "highlights-content__notes highlights-content__notes--edit" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h3", { class: "highlights-content__title" }, "Your Notes", -1)
const _hoisted_20 = { class: "highlights-content__btn-box" }
const _hoisted_21 = {
  key: 1,
  class: "highlights-content__share"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "highlights-content__share-btn-box highlights-content__share-btn-box--hide-m" }, null, -1)
const _hoisted_23 = { class: "highlights-content__share-link" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "iconfont ilink" }, null, -1)
const _hoisted_25 = {
  key: 2,
  class: "highlights-content__from"
}
const _hoisted_26 = { class: "highlights-content__from-text" }

import { nextTick, ref } from 'vue'

import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'

import { setFocus } from '@/helpers/form'
import { formatDate } from '@/helpers/time'
import { backend } from '@/services/backend'
import { ContentView, AnnotationView } from '@/models/doc'
import { DocView } from '@/models/doc'
import IconButton from '@/app/components/button/IconButton.vue'
import DeleteHighlightPopup from './DeleteHighlightPopup.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Highlight',
  props: {
    doc: null,
    content: null,
    highlight: null,
    showFrom: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { doc: DocView, content: ContentView, highlight: AnnotationView, showFrom: boolean };



const deletePopup = ref<InstanceType<typeof DeleteHighlightPopup> | null>(null)
const input = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

const highlightEditId = ref('')
const copyTooltip = ref('Copy')

function copyHighlight(highlight: AnnotationView): void {
  props.doc.copyHighlight(highlight)
  copyTooltip.value = 'Copied!'
  setTimeout(() => {
    copyTooltip.value = 'Copy'
  }, 2000)
}

function showDeletePopup(highlight: AnnotationView): void {
  deletePopup.value?.show(highlight)
}

function deleteHighlight(highlight: AnnotationView): void {
  props.doc.deleteHighlight(highlight)
}

function toggleEdit(highlight: AnnotationView): void {
  if (highlightEditId.value) {
    highlightEditId.value = ''
  } else {
    highlightEditId.value = highlight.id
    nextTick(() => {
      // Focus the edtior field after switching to edit mode.
      setFocus(input.value?.$el as HTMLElement)
    })
  }
}

function saveEdit(highlight: AnnotationView): void {
  // Save highlight note changes.
  backend.updateHighlightNote(highlight)
  toggleEdit(highlight)
}

function getDate(): string {
  if (props.highlight.created) {
    return formatDate(props.highlight.created)
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (__props.highlight.highlight_type === 'bookmark')
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "highlights-content__blockquote-image",
              src: require('@/assets.app/images/blockquote.svg')
            }, null, 8, _hoisted_7)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(IconButton, {
            icon: "ikindle-copy",
            tooltip: copyTooltip.value,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (copyHighlight(__props.highlight)))
          }, null, 8, ["tooltip"])
        ])
      ]),
      _createElementVNode("blockquote", _hoisted_9, _toDisplayString(__props.highlight.quote), 1),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "highlights-content__link",
          to: __props.highlight.contentLink
        }, {
          default: _withCtx(() => [
            _createTextVNode("Go to " + _toDisplayString(__props.highlight.highlight_type === 'bookmark' ? 'bookmark' : 'highlight') + " ", 1),
            _hoisted_11
          ]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("p", _hoisted_12, [
          _createTextVNode(_toDisplayString(__props.highlight.highlight_type === 'bookmark'
              ? 'Bookmarked on'
              : 'Highlighted on') + ": ", 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(getDate()), 1)
        ]),
        _createElementVNode("button", {
          class: "highlights-content__delete-btn",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeletePopup(__props.highlight)))
        }, " Delete "),
        _createVNode(DeleteHighlightPopup, {
          ref_key: "deletePopup",
          ref: deletePopup,
          onConfirmDelete: deleteHighlight
        }, null, 512)
      ])
    ]),
    (
        __props.highlight.id !== highlightEditId.value &&
        __props.highlight.highlight_type !== 'bookmark'
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("p", {
            class: "highlights-content__text add-finished",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (toggleEdit(__props.highlight)))
          }, [
            (__props.highlight.text)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(__props.highlight.text), 1))
              : (_openBlock(), _createElementBlock("em", _hoisted_17, " Add note "))
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("form", null, [
        _createVNode(InputWithContextMenu, {
          ref_key: "input",
          ref: input,
          modelValue: __props.highlight.text,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((__props.highlight.text) = $event)),
          elementType: "textarea",
          type: "text",
          class: "highlights-content__text",
          onBlur: _cache[4] || (_cache[4] = ($event: any) => (saveEdit(__props.highlight)))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_20, [
        (highlightEditId.value && __props.highlight.id === highlightEditId.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "highlights-content__btn highlights-content__btn--save btns btns--minimum",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (saveEdit(__props.highlight)))
            }, " Save "))
          : _createCommentVNode("", true),
        (highlightEditId.value && __props.highlight.id === highlightEditId.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "highlights-content__btn highlights-content__btn--cancel btns btns--minimum btns--white",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (toggleEdit(__props.highlight)))
            }, " Cancel "))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, 
        highlightEditId.value === __props.highlight.id &&
        __props.highlight.highlight_type !== 'bookmark'
      ]
    ]),
    (__props.highlight.is_public)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_router_link, {
              to: __props.highlight.publicLink,
              class: "highlights-content__share-link-c"
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.showFrom)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("p", _hoisted_26, [
            _createTextVNode(" From: "),
            _createVNode(_component_router_link, {
              class: "highlights-content__from-link",
              to: __props.highlight.contentLink
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.content.doc.title) + ". By " + _toDisplayString(__props.content.doc.author), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})